import type { TranslationDict } from '../en';

const ml: TranslationDict = {
  'header.buy': 'വാങ്ങുക',
  'header.sell': 'വിൽക്കുക',
  'spend.label': 'നിങ്ങൾ ചെലവഴിക്കുന്നത്',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'നിങ്ങൾക്ക് ലഭിക്കുന്നത്',
  'payment.label': 'പേയ്‌മെന്റ് രീതി',
  'payment.select': 'തിരഞ്ഞെടുക്കുക',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'ഈ ജോടിക്ക് പേയ്‌മെന്റ് രീതികൾ ലഭ്യമല്ല',
  'wallet.label': 'സ്വീകരിക്കുന്ന വാലറ്റ് വിലാസം',
  'wallet.placeholderBuy': 'നിങ്ങളുടെ സ്വീകരിക്കുന്ന വിലാസം നൽകുക',
  'wallet.placeholderSell': 'നിങ്ങളുടെ അയക്കുന്ന വിലാസം നൽകുക',
  'wallet.validating': 'വിലാസം പരിശോധിക്കുന്നു...',
  'wallet.invalid': 'സാധുവായ വാലറ്റ് വിലാസം നൽകുക',
  'wallet.invalidServer': 'അസാധുവായ വാലറ്റ് വിലാസം',
  'cta.buy': '{crypto} വാങ്ങുക',
  'cta.sell': '{crypto} വിൽക്കുക',
  'cta.gettingPrice': 'മികച്ച വില ലഭ്യമാക്കുന്നു...',
  'cta.processing': 'പ്രോസസ്സ് ചെയ്യുന്നു...',
  'footer.poweredBy': 'ഇവർ നൽകുന്നു ',
  'footer.brand': 'NowRamp',
  'rate.title': 'നിരക്ക് വിശദാംശങ്ങൾ',
  'rate.close': 'അടയ്ക്കുക',
  'rate.updatesIn': 'നിരക്ക് 00:{seconds} ൽ അപ്ഡേറ്റ് ആകും',
  'rate.noQuote': 'ക്വോട്ടേഷൻ ലഭ്യമല്ല',
  'rate.exchangeRate': 'വിനിമയ നിരക്ക്',
  'rate.processingFee': 'പ്രോസസ്സിംഗ് ഫീ',
  'rate.networkFee': 'നെറ്റ്‌വർക്ക് ഫീ',
  'rate.provider': 'സേവന ദാതാവ്',
  'toast.orderCreated': 'ഓർഡർ സൃഷ്ടിച്ചു',
  'toast.redirecting': 'ചെക്ക്ഔട്ടിലേക്ക് റീഡയറക്ട് ചെയ്യുന്നു...',
  'toast.orderFailed': 'ഓർഡർ പരാജയപ്പെട്ടു',
  'toast.couldNotCreate': 'ഓർഡർ സൃഷ്ടിക്കാൻ കഴിഞ്ഞില്ല',
  'toast.quoteError': 'ക്വോട്ടേഷൻ പിശക്',
  'toast.noProviders': 'സേവന ദാതാക്കൾ ഇല്ല',
  'toast.somethingWrong': 'എന്തോ തകരാർ സംഭവിച്ചു',
  'error.amountZero': 'തുക 0-ൽ കൂടുതൽ ആയിരിക്കണം',
  'error.minAmountFiat': 'കുറഞ്ഞ തുക {min} {currency} ആണ്',
  'error.minAmountCrypto': 'കുറഞ്ഞ തുക {min} {currency} ആണ്',
  'error.noProviders': 'ഈ സംയോജനത്തിന് സേവന ദാതാക്കൾ ലഭ്യമല്ല',
  'error.currencyUnavailableBuy': 'ഈ കറൻസി വാങ്ങൽ ഓർഡറുകൾക്ക് ലഭ്യമല്ല',
  'error.currencyUnavailableSell': 'ഈ കറൻസി വിൽക്കൽ ഓർഡറുകൾക്ക് ലഭ്യമല്ല',
  'parity.info': 'നിങ്ങളിൽ നിന്ന് {receiveAmount} {crypto} ക്ക് ചാർജ് ഈടാക്കും, ബാക്കി {spendAmount} {fiat} വരെയുള്ള തുക നിങ്ങളുടെ {partner} അക്കൗണ്ടിൽ ക്രെഡിറ്റ് ചെയ്യും',
  'redirect.secureBadge': 'സുരക്ഷിത പേയ്‌മെന്റ്',
  'redirect.title': 'പേയ്‌മെന്റ് തുടരുക',
  'redirect.description': 'നിങ്ങളുടെ പേയ്‌മെന്റ് പൂർത്തിയാക്കാൻ {gateway} ലേക്ക് റീഡയറക്ട് ചെയ്യും.',
  'redirect.countdown': '{seconds} ൽ റീഡയറക്ട് ചെയ്യുന്നു...',
  'redirect.openTab': 'പുതിയ ടാബിൽ ACH തുറക്കുക',
  'redirect.cancel': 'റദ്ദ് ചെയ്യുക',
  'checkout.noOrder': 'ഓർഡർ കണ്ടെത്തിയില്ല',
  'checkout.goBack': 'തിരിച്ചു പോകുക',
  'checkout.expired': 'ചെക്ക്ഔട്ട് കാലഹരണപ്പെട്ടു',
  'checkout.expiredDesc': 'സെഷൻ കാലഹരണപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
  'checkout.startOver': 'വീണ്ടും ആരംഭിക്കുക',
  'checkout.cancel': 'റദ്ദ് ചെയ്യുക',
  'checkout.loading': 'ചെക്ക്ഔട്ട് ലോഡ് ചെയ്യുന്നു...',
  'checkout.iframeTitle': 'ദാതാവ് ചെക്ക്ഔട്ട്',
  'checkout.widgetTitle': 'പേയ്‌മെന്റ് ചെക്ക്ഔട്ട്',
  'checkout.unknownMethod': 'അജ്ഞാത ചെക്ക്ഔട്ട് രീതി',
  'processing.default': 'നിങ്ങളുടെ ഓർഡർ പ്രോസസ്സ് ചെയ്യുന്നു...',
  'processing.pending': 'പേയ്‌മെന്റ് സ്ഥിരീകരണത്തിനായി കാത്തിരിക്കുന്നു...',
  'processing.active': 'നിങ്ങളുടെ ഇടപാട് പ്രോസസ്സ് ചെയ്യുന്നു...',
  'processing.generic': 'പ്രോസസ്സ് ചെയ്യുന്നു...',
  'processing.checkingStatus': 'സ്ഥിതി പരിശോധിക്കുന്നു...',
  'processing.orderId': 'ഓർഡർ ID',
  'processing.provider': 'സേവന ദാതാവ്',
  'processing.amount': 'തുക',
  'processing.receiving': 'സ്വീകരിക്കുന്നു',
  'processing.network': 'നെറ്റ്‌വർക്ക്',
  'processing.toAddress': 'ലക്ഷ്യ വിലാസം',
  'processing.usuallyMinutes': 'ഇതിന് സാധാരണ കുറച്ച് മിനിറ്റ് എടുക്കും.',
  'processing.safeToClose': 'ഈ പേജ് സുരക്ഷിതമായി അടയ്ക്കാം - പൂർത്തിയാകുമ്പോൾ ഞങ്ങൾ നിങ്ങൾക്ക് ഇമെയിൽ അയക്കും.',
  'complete.buyTitle': 'വാങ്ങൽ പൂർത്തിയായി!',
  'complete.sellTitle': 'വിൽക്കൽ പൂർത്തിയായി!',
  'complete.buyDesc': 'നിങ്ങളുടെ {crypto} നിങ്ങളുടെ വാലറ്റിലേക്ക് അയച്ചു.',
  'complete.sellDesc': 'നിങ്ങളുടെ {fiat} പേഔട്ട് പ്രോസസ്സ് ചെയ്യുന്നു.',
  'complete.amountBuy': 'ലഭിച്ച തുക',
  'complete.amountSell': 'വിറ്റ തുക',
  'complete.paidBuy': 'നൽകിയ തുക',
  'complete.paidSell': 'പേഔട്ട് തുക',
  'complete.network': 'നെറ്റ്‌വർക്ക്',
  'complete.wallet': 'വാലറ്റ്',
  'complete.transaction': 'ഇടപാട്',
  'complete.provider': 'സേവന ദാതാവ്',
  'complete.orderId': 'ഓർഡർ ID',
  'complete.completed': 'പൂർത്തിയായി',
  'complete.viewExplorer': 'എക്‌സ്‌പ്ലോററിൽ കാണുക',
  'complete.done': 'കഴിഞ്ഞു',
  'errorStep.failed': 'പേയ്‌മെന്റ് പരാജയപ്പെട്ടു',
  'errorStep.cancelled': 'ഓർഡർ റദ്ദാക്കി',
  'errorStep.expired': 'ഓർഡർ കാലഹരണപ്പെട്ടു',
  'errorStep.refunded': 'ഓർഡർ തിരിച്ചടച്ചു',
  'errorStep.unknown': 'എന്തോ തകരാർ സംഭവിച്ചു',
  'errorStep.failedBuy': 'നിങ്ങളുടെ പേയ്‌മെന്റ് പ്രോസസ്സ് ചെയ്യാൻ കഴിഞ്ഞില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ മറ്റൊരു പേയ്‌മെന്റ് രീതി ഉപയോഗിക്കുക.',
  'errorStep.failedSell': 'നിങ്ങളുടെ വിൽക്കൽ പ്രോസസ്സ് ചെയ്യാൻ കഴിഞ്ഞില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
  'errorStep.cancelledBuy': 'നിങ്ങളുടെ ഓർഡർ റദ്ദാക്കി. ഒരു പേയ്‌മെന്റും പ്രോസസ്സ് ചെയ്തിട്ടില്ല.',
  'errorStep.cancelledSell': 'നിങ്ങളുടെ വിൽക്കൽ റദ്ദാക്കി. ക്രിപ്‌റ്റോ ഒന്നും കൈമാറ്റം ചെയ്തിട്ടില്ല.',
  'errorStep.expiredBuy': 'നിങ്ങളുടെ ഓർഡർ കാലഹരണപ്പെട്ടു. ദയവായി പുതിയ വാങ്ങൽ ആരംഭിക്കുക.',
  'errorStep.expiredSell': 'നിങ്ങളുടെ ഓർഡർ കാലഹരണപ്പെട്ടു. ദയവായി പുതിയ വിൽക്കൽ ആരംഭിക്കുക.',
  'errorStep.refundedBuy': 'നിങ്ങളുടെ പേയ്‌മെന്റ് തിരിച്ചടച്ചു. 5-10 പ്രവൃത്തി ദിവസങ്ങൾക്കുള്ളിൽ തുക നിങ്ങളുടെ അക്കൗണ്ടിൽ ദൃശ്യമാകും.',
  'errorStep.refundedSell': 'നിങ്ങളുടെ ക്രിപ്‌റ്റോ തിരിച്ചയച്ചു. ഉടൻ തന്നെ തുക നിങ്ങളുടെ വാലറ്റിൽ ദൃശ്യമാകും.',
  'errorStep.genericDesc': 'അപ്രതീക്ഷിത പിശക് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
  'errorStep.orderId': 'ഓർഡർ ID',
  'errorStep.tryAgain': 'വീണ്ടും ശ്രമിക്കുക',
  'errorStep.startOver': 'വീണ്ടും ആരംഭിക്കുക',
  'errorStep.return': 'തിരിച്ചു പോകുക',
  'errorStep.needHelp': 'സഹായം വേണോ? ബന്ധപ്പെടുക ',
  'errorStep.reference': 'റഫറൻസ്: {orderId}',
  'confirm.buyTitle': 'വാങ്ങൽ സ്ഥിരീകരിക്കുക',
  'confirm.sellTitle': 'വിൽക്കൽ സ്ഥിരീകരിക്കുക',
  'confirm.loading': 'ലോഡ് ചെയ്യുന്നു...',
  'confirm.provider': 'സേവന ദാതാവ്',
  'confirm.youPay': 'നിങ്ങൾ നൽകുന്നത്',
  'confirm.youSell': 'നിങ്ങൾ വിൽക്കുന്നത്',
  'confirm.youReceive': 'നിങ്ങൾക്ക് ലഭിക്കുന്നത്',
  'confirm.wallet': 'വാലറ്റ്',
  'confirm.network': 'നെറ്റ്‌വർക്ക്',
  'confirm.refundAddress': 'റീഫണ്ട് വിലാസം',
  'confirm.parityNote': 'ദാതാവ് ഈടാക്കുന്ന തുക വ്യത്യസ്തമായേക്കാം. ബാക്കി {amount} {crypto} വരെയുള്ള തുക നിങ്ങളുടെ {partner} അക്കൗണ്ടിൽ ക്രെഡിറ്റ് ചെയ്യും.',
  'confirm.processing': 'പ്രോസസ്സ് ചെയ്യുന്നു...',
  'confirm.confirmPay': 'സ്ഥിരീകരിച്ച് നൽകുക',
  'confirm.confirmSell': 'സ്ഥിരീകരിച്ച് വിൽക്കുക',
  'confirm.payout': '{currency} പേഔട്ട്',
  'modal.selectFiat': 'ഫിയറ്റ് കറൻസി തിരഞ്ഞെടുക്കുക',
  'modal.selectCrypto': 'ക്രിപ്‌റ്റോ കറൻസി തിരഞ്ഞെടുക്കുക',
  'modal.choosePayment': 'പേയ്‌മെന്റ് രീതി തിരഞ്ഞെടുക്കുക',
  'modal.selectCountry': 'നിങ്ങളുടെ രാജ്യം തിരഞ്ഞെടുക്കുക',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'ജനപ്രിയ',
  'modal.recommended': 'ശുപാർശ ചെയ്തത്',
  'modal.noCurrencies': 'കറൻസികൾ ഒന്നും കണ്ടെത്തിയില്ല',
  'modal.noPaymentMethods': 'പേയ്‌മെന്റ് രീതികൾ ഒന്നും കണ്ടെത്തിയില്ല',
  'modal.noCountries': 'രാജ്യങ്ങൾ ഒന്നും കണ്ടെത്തിയില്ല',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'സ്ഥാനം',
  'settings.darkMode': 'ഡാർക്ക് മോഡ്',
  'settings.privacy': 'സ്വകാര്യതാ നയം',
  'settings.terms': 'ഉപയോഗ നിബന്ധനകൾ',
  'settings.language': 'ഭാഷ',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp തിരഞ്ഞെടുക്കുക',
  'modal.bestPrice': 'മികച്ച വില',
  'modal.noQuotes': 'ഈ അഭ്യർത്ഥനക്ക് ക്വോട്ടേഷനുകൾ ഒന്നും ലഭ്യമല്ല',
  'modal.noProvidersFound': 'സേവന ദാതാക്കൾ ആരും കണ്ടെത്തിയില്ല',
  'payment.unavailableFor': '{currency} നു പേയ്‌മെന്റ് രീതികൾ ഒന്നും ലഭ്യമല്ല',
  'skeleton.poweredBy': 'NowRamp നൽകുന്നു',
  'error.createOrderFailed': 'ഓർഡർ സൃഷ്ടിക്കുന്നതിൽ പരാജയപ്പെട്ടു',
  'errorStep.returnToMerchant': 'വ്യാപാരിയിലേക്ക് മടങ്ങുക',
  'confirm.cryptoOnNetwork': '{crypto} {network} ൽ',
  'payment.name.card': 'കാർഡ്',
  'payment.name.bankTransfer': 'ബാങ്ക് ട്രാൻസ്ഫർ',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ml;
